"use client";

import { c as _c } from "react/compiler-runtime";
import Placeholder from "@tiptap/extension-placeholder";
import { EditorContent, useEditor } from "@tiptap/react";
import StarterKit from "@tiptap/starter-kit";
import { EntryEditorToolbar } from "@/components/wiki/entry-editor-toolbar";
const EMPTY_DOCUMENT = {
  type: "doc",
  content: [{
    type: "paragraph"
  }]
};
export function DemoWikiPageEditor(t0) {
  const $ = _c(13);
  const {
    initialContent,
    onChange
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [StarterKit.configure({
      heading: {
        levels: [2, 3]
      }
    }), Placeholder.configure({
      placeholder: "Start documenting this page\u2026"
    })];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = initialContent ?? EMPTY_DOCUMENT;
  let t3;
  if ($[1] !== onChange) {
    t3 = t4 => {
      const {
        editor: currentEditor
      } = t4;
      onChange(currentEditor.getJSON(), currentEditor.getText());
    };
    $[1] = onChange;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== t2 || $[4] !== t3) {
    t4 = {
      immediatelyRender: false,
      extensions: t1,
      content: t2,
      onUpdate: t3
    };
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const editor = useEditor(t4);
  let t5;
  if ($[6] !== editor) {
    t5 = <EntryEditorToolbar editor={editor} />;
    $[6] = editor;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== editor) {
    t6 = <div className="lore-editor-content rich-content min-h-[420px] overflow-y-auto rounded-b-lg border border-border/50 bg-background"><EditorContent editor={editor} className="max-w-none p-4" /></div>;
    $[8] = editor;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t5 || $[11] !== t6) {
    t7 = <div>{t5}{t6}</div>;
    $[10] = t5;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  return t7;
}